import * as cnLang from '@/i18n/lang/cn';
import * as enLang from '@/i18n/lang/en';
import Vue from 'vue';
import VueI18n from 'vue-i18n'
import store from './store'
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: store.state.app.language,
  messages: {
    cn: cnLang,
    en: enLang
  }
});
export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js